import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: Metricate.UserPermissionsState = {
  admin_view: false,
  admin_lsa: false,
  admin_appeal: false,
  admin_incentives: false,
  admin_production: false,
  admin_access: false,
  admin_content: false,
  lsa_create: false,
  appeal_create: false,
  appeal_approve: false,
  reports_view: false,
  downtime_approve: false,
  additional_volume_approve: false,
  external_leave_create: false,
  team_manage: false,
}

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<string[]>) => {
      Object.assign(state, initialState)

      action.payload.forEach((role) => {
        switch (role) {
          case "admin-view":
            state.admin_view = true
            break
          case "admin-lsa":
            state.admin_lsa = true
            break
          case "admin-appeal":
            state.admin_appeal = true
            break
          case "admin-incentives":
            state.admin_incentives = true
            break
          case "admin-production":
            state.admin_production = true
            break
          case "admin-access":
            state.admin_access = true
            break
          case "admin-content":
            state.admin_content = true
            break
          case "lsa-create":
            state.lsa_create = true
            break
          case "appeal-create":
            state.appeal_create = true
            break
          case "appeal-approve":
            state.appeal_approve = true
            break
          case "reports-view":
            state.reports_view = true
            break
          case "downtime-approve":
            state.downtime_approve = true
            break
          case "additional-volume-approve":
            state.additional_volume_approve = true
            break
          case "external-leave-create":
            state.external_leave_create = true
            break
          case "team-manage":
            state.team_manage = true
            break
        }
      })
    },
  },
})

export const { setPermissions } = permissionsSlice.actions
export default permissionsSlice.reducer
